module.exports = __webpack_public_path__ + "img/mul_users.ad728b54.svg";